import type { MessagesQueryParams } from "./types";

// Helper function to fetch messages from the API
export async function fetchMessages(
  provider: string,
  params: MessagesQueryParams,
  token: string
) {
  const searchParams = new URLSearchParams({
    connectionId: params.connectionId,
    limit: (params.limit || 25).toString(),
    skip: (params.skip || 0).toString(),
  });

  if (params.filter && params.filter !== "all") {
    searchParams.append("filter", params.filter);
  }

  const response = await fetch(`/api/connections/messages/${provider}?${searchParams}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch messages");
  }

  return response.json();
}
